module.exports = __webpack_public_path__ + "img/hertford_b1.e45366db.jpg";